module.exports = __webpack_public_path__ + "static/media/QuickBooks-Online-First-Image.3fb00e7d.jpg";